import type { GA4PageNameType } from '@/ga4types'
import analytics from '@/shared-utils/analytics'
import type { ProductType } from '@/types'

export default function logSearchFormAnalytics(
  cguid: string,
  pageName: GA4PageNameType,
  productType: ProductType | 'multi-hotel',
  isMobile: boolean,
) {
  analytics.log({
    message: 'User submitted search form',
    cguid,
    searchForm: productType,
    pageName,
    isMobile,
  })
}
